module.exports = __webpack_public_path__ + "ab7a49a4237b02f41aa6905639dc81de.jpg";